import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {BaseComponent} from './base/base.component';
import {NavbarComponent} from './navbar/navbar.component';
import {SidebarComponent} from './sidebar/sidebar.component';
import {FooterComponent} from './footer/footer.component';
import {UserContractsComponentComponent} from './user-contracts-component/user-contracts-component.component';
import {PanelMenuModule} from 'primeng/panelmenu';
import {NgbCollapseModule, NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';

import {ProgressSpinnerModule} from "primeng/progressspinner";
import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {AvatarModule} from "primeng/avatar";
import {TranslateModule} from "@ngx-translate/core";
import {ContentAnimateDirective} from "../core/content-animate/content-animate.directive";
import {FeatherIconModule} from "../core/feather-icon/feather-icon.module";
import {DropdownModule} from 'primeng/dropdown';
import {ClipboardModule} from "ngx-clipboard";
import {ToastModule} from 'primeng/toast';
import {CapitalizePipe} from '../lib/pipes/capitalize.pipe';
import {CarouselModule} from 'ngx-bootstrap/carousel';
import {FileUploadModule} from "primeng/fileupload";
import {MsConverterPipe} from '../lib/pipes/ms-converter.pipe';
import {NotificationComponent} from '../components/notifications/notification.component';
import {BuildNotificationTemplatePipe} from '../lib/pipes/build-notification-template.pipe';
import {CarouselModule as CarouselPrimeng} from 'primeng/carousel';
import {ButtonModule} from 'primeng/button';
import {DialogModule} from "primeng/dialog";
import {InputTextareaModule} from "primeng/inputtextarea";
import {InputTextModule} from 'primeng/inputtext';
import {SystemConfigurationComponent} from '../components/system-configuration/system-configuration.component';
import {ChangePasswordComponent} from "../components/change-password/change-password.component";
import {PasswordModule} from "primeng/password";
import {ActivateLocationComponent} from "../components/activate-location/activate-location.component";
import {MonexUltra2Component} from "../components/monex-ultra/monex-ultra2.component";
import {PasswordSuccessComponent} from "../components/password-success/password-success.component";
import {
    PendingAuthorizationsListModalComponent
} from "../components/pending-authorizations-list-modal/pending-authorizations-list-modal.component";
import {DividerModule} from "primeng/divider";


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true
};


@NgModule({
    declarations: [
        BaseComponent,
        NavbarComponent,
        SidebarComponent,
        FooterComponent,
        ContentAnimateDirective,
        UserContractsComponentComponent,
        NotificationComponent,
        CapitalizePipe,
        MsConverterPipe,
        SystemConfigurationComponent,
        BuildNotificationTemplatePipe,
        ChangePasswordComponent,
        ActivateLocationComponent,
        MonexUltra2Component,
        PasswordSuccessComponent,
        PendingAuthorizationsListModalComponent

    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        CarouselPrimeng,
        NgbDropdownModule,
        NgbCollapseModule,
        PerfectScrollbarModule,
        FeatherIconModule,
        AvatarModule,
        TranslateModule,
        DropdownModule,
        ClipboardModule,
        ToastModule,
        PanelMenuModule,
        CarouselModule,
        PanelMenuModule,
        FileUploadModule,
        ProgressSpinnerModule,
        ButtonModule,
        DialogModule,
        InputTextareaModule,
        InputTextModule,
        ReactiveFormsModule,
        PasswordModule,
        DividerModule
    ],
    providers: [
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        }
    ],
    exports: [ChangePasswordComponent, ActivateLocationComponent, NavbarComponent]
})
export class LayoutModule {
}
